import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { createDocumentType } from '@/shared/actions/erp';
import { CustomTextField, SingleFormBoxScene } from '@/shared/components/ui';
import { newDoctypeSchema } from '@/shared/utils';

const returnUrl = '/configuracion/tipos-documentos';

export type CreateDocumentTypePageProps = {};

export type CreateFormData = {
  nombre: string;
};

const CreateDocumentTypePage: React.FC<CreateDocumentTypePageProps> = () => {
  const navigate = useNavigate();

  ////* form
  const form = useForm<CreateFormData>({
    resolver: yupResolver(newDoctypeSchema),
  });

  const {
    handleSubmit,
    formState: { errors, isValid },
  } = form;

  const onSave = async () => {
    if (!isValid) return;
    await createDocumentType(form.getValues());
    navigate('/configuracion/tipos-documentos');
  };

  return (
    <SingleFormBoxScene
      titlePage="Crear tipo de documento"
      onCancel={() => {
        navigate(returnUrl);
      }}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField
        label="Nombre"
        name="nombre"
        control={form.control}
        defaultValue={form.getValues().nombre || ''}
        error={errors.nombre}
        helperText={errors.nombre?.message ?? ''}
      />
    </SingleFormBoxScene>
  );
};

export default CreateDocumentTypePage;
